import { render, staticRenderFns } from "./point-order-detail-ticket.vue?vue&type=template&id=db5cf30c"
import script from "./point-order-detail-ticket.vue?vue&type=script&lang=js"
export * from "./point-order-detail-ticket.vue?vue&type=script&lang=js"
import style0 from "./point-order-detail-ticket.vue?vue&type=style&index=0&id=db5cf30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports